import { gql } from '@ts-gql/tag';
import { useMutation } from '@ts-gql/apollo';

import { GET_JOB_COMMENTS_QUERY as getJobCommentsQuery } from './useGetJobComments';

const mutation = gql`
  mutation DeleteJobComment($cloudId: String!) {
    deleteJobComment(input: { cloudId: $cloudId }) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/DeleteJobComment').type;

// let's do something different here - take jobId into the use part of the hook
// We need the JobId to re-run getJobComments, which is actually getJob internally
// We can't just evict getJob, that'd be foolish
// We could have put the responsibility on the consumer to refetch the comments, but that didn't feel right
// when a simple parameter here allows this mutation to do it's own refetching
export const useDeleteJobComment = (jobId: string) => {
  const tuple = useMutation(mutation);

  const [_mutate, result] = tuple;

  const mutate = (options: Parameters<typeof _mutate>[0]) => {
    if (!options.variables) {
      throw new Error('variables are required in useDeleteJobComment');
    }

    return _mutate({
      context: { service: 'core' },
      refetchQueries: [
        {
          query: getJobCommentsQuery,
          variables: { cloudId: jobId },
        } as unknown as 'GetJobComments',
      ],
      awaitRefetchQueries: true,
      ...options,
    });
  };
  return [mutate, result] as const;
};
